import { ReactNode } from "react";
import BottomNav from "./BottomNav";

export default function AppShell({ children }: { children: ReactNode }) {
  return (
    <div className="app-shell pb-20">
      {children}
      <BottomNav />
    </div>
  );
}